import { faArrowToBottom, faTimes, faTimesCircle } from "@fortawesome/pro-regular-svg-icons";
import { createRef, Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilesToDownload } from "extensions/fa5-icons/faFilesToDownload";

import { emitter } from "common/emitter";

import { pazienHistory } from "common/components/pazienHistory";

import {
    MARK_DOWNLOAD_READ,
    MARK_ALL_DOWNLOADS_READ
} from "common/actions/downloads";
import { DOWNLOAD_REPORT } from "common/actions/common";
import { PanelIcon, HeaderActions, NotificationPopup, PanelHeader, Title, FullHeightList, NoDataAvailable, RowItem } from "./notificationPopup";

import { PopupActions } from "./popup_actions";

const mapStateToProps = (state) => ({
    loading: state.downloads.loading,
    loaded: state.downloads.loaded,
    NotificationsData: state.downloads.downloads_data
});

const mapDispatchToProps = {
    MARK_DOWNLOAD_READ,
    MARK_ALL_DOWNLOADS_READ,
    DOWNLOAD_REPORT
};

class downloadsPopup extends Component {
    static viewAll(close) {
        pazienHistory.navigateWithParams("/downloads", { trigger: true });
        setTimeout(close(), 0);
    }
    
    constructor(props) {
        super(props);
        this.popupRef = createRef();
        this.state = {
            panelOpen: false
        };
    }
    
    componentDidMount() {
        emitter.on("open.downloadsPanel", this.forceOpenPanel);
    }
    
    componentWillUnmount() {
        emitter.off("open.downloadsPanel", this.forceOpenPanel);
    }
    
    clearAll = () => {
        this.props.MARK_ALL_DOWNLOADS_READ();
    };
    
    forceOpenPanel = () => {
        this.setState({ panelOpen: true });
    };
    
    renderItems() {
        const onlyUnread = this.props.NotificationsData.filter((n) => n.acknowledged === false);
        if (onlyUnread.length === 0) {
            return <NoDataAvailable>You have no new downloads</NoDataAvailable>;
        }
        
        return onlyUnread.map((i, index) => (
            <RowItem key={`download_item_${i._id}`}>
                <div className="icon download" onClick={() => this.props.DOWNLOAD_REPORT(i.refs.job)}>
                    <FontAwesomeIcon icon={faArrowToBottom} />
                </div>
                <div className="info">
                    <div className="title">{i.filename}</div>
                    <div className="date">{moment.utc(i.modified).local().format("MMM DD, YYYY")}</div>
                </div>
                <div className="icon close" onClick={() => this.props.MARK_DOWNLOAD_READ(i._id)}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            </RowItem>
        ));
    }
    
    render() {
        const closeMe = () => {
            this.popupRef.current.close();
            this.setState({ panelOpen: false });
        };
        
        const onlyUnread = this.props.NotificationsData.filter((n) => n.acknowledged === false);
        
        return (
            <NotificationPopup
                ref={this.popupRef}
                icon={faFilesToDownload}
                forceOpen={this.state.panelOpen}
                iconStyle="downloads"
                title="Downloads"
                hasIndicator={onlyUnread.length > 0}
                onVisibilityChange={this.props.onVisibilityChange}
            >
                <div>
                    <PanelHeader>
                        <Title>Downloads</Title>
                        <HeaderActions>
                            <PanelIcon onClick={closeMe}><FontAwesomeIcon icon={faTimes} size="lg" /></PanelIcon>
                        </HeaderActions>
                    </PanelHeader>
                    <PopupActions viewAll={() => downloadsPopup.viewAll(closeMe)} clearAll={this.clearAll} hasItems={(onlyUnread.length > 0)}/>
                    <FullHeightList>{this.renderItems()}</FullHeightList>
                </div>
            </NotificationPopup>
        );
    }
}

export const DownloadsPopup = connect(mapStateToProps, mapDispatchToProps)(downloadsPopup);
